module.exports = __webpack_public_path__ + "static/img/kejijinbu.51dbb24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/kejijinbu.jpg
// module id = drmo
// module chunks = 7